export const states_data = [
  {
    key: '1',
    stateName: 'California',
    countryName: 'United States',
    status: 'Active'
  },
  {
    key: '2',
    stateName: 'New York',
    countryName: 'United States',
    status: 'Active'
  },
  {
    key: '3',
    stateName: 'Texas',
    countryName: 'United States',
    status: 'Active'
  },
  {
    key: '4',
    stateName: 'Bavaria',
    countryName: 'Germany',
    status: 'Active'
  },
  {
    key: '5',
    stateName: 'Quebec',
    countryName: 'Canada',
    status: 'Active'
  },
  {
    key: '6',
    stateName: 'Ontario',
    countryName: 'Canada',
    status: 'Active'
  },
  {
    key: '7',
    stateName: 'Florida',
    countryName: 'United States',
    status: 'Active'
  },
  {
    key: '8',
    stateName: 'Berlin',
    countryName: 'Germany',
    status: 'Active'
  },
  {
    key: '9',
    stateName: 'Victoria',
    countryName: 'Australia',
    status: 'Active'
  },
  {
    key: '10',
    stateName: 'Gauteng',
    countryName: 'Egypt',
    status: 'Active'
  }
];
